import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

const EDIT_STILLER = `
  :host { display: block; }
  .dg-edit { display: flex; flex-direction: column; padding: 0; }
  .dg-baslik { display: flex; align-items: center; gap: 10px; padding: 12px 16px; margin-bottom: 4px; border-radius: 10px; background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent); }
  .dg-baslik-ikon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #0ea5e9, #38bdf8); color: #fff; flex-shrink: 0; box-shadow: 0 2px 8px rgba(14,165,233,0.35); }
  .dg-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }
  .dg-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }
  .form-grup { display: flex; flex-direction: column; gap: 5px; }
  .form-grup label { font-size: 11px; font-weight: 500; color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px; transition: color 0.2s; }
  .form-grup:focus-within label { color: var(--py-link, #1890ff); }
  .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }
  .input-wrap { position: relative; }
  .input-glow { position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px; background: linear-gradient(90deg, #0ea5e9, #38bdf8, #0ea5e9); transition: width 0.35s cubic-bezier(0.4,0,0.2,1), left 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.3s; opacity: 0; pointer-events: none; z-index: 1; }
  .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }
  .input-wrap input[nz-input], .input-wrap textarea[nz-input] { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)); border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px; padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333); transition: border-color 0.25s, background 0.25s, box-shadow 0.25s; }
  .input-wrap input[nz-input]:focus, .input-wrap textarea[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(14,165,233,0.1); outline: none; }
  .input-wrap ::ng-deep .ant-select-selector { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important; border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px; }
  .input-wrap:focus-within ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-aktif, #1890ff) !important; box-shadow: 0 0 0 2px rgba(14,165,233,0.1) !important; }
  .ac-opt { display: flex; align-items: center; gap: 8px; }
  .ac-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
`;

@Component({
  selector: 'durum-guncelleme-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dg-edit">
      <div class="dg-baslik">
        <div class="dg-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/><path d="M9 12l2 2 4-4"/></svg>
        </div>
        <span>Durum Güncellemesi</span>
      </div>

      <div class="dg-form">
        <div class="form-grup">
          <label>Durum <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select [ngModel]="deger('durum') || 'Bekliyor'" (ngModelChange)="guncelle('durum', $event)" style="width:100%">
              <nz-option nzValue="Bekliyor" nzLabel="Bekliyor" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#94a3b8"></span>Bekliyor</span></nz-option>
              <nz-option nzValue="İnceleniyor" nzLabel="İnceleniyor" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#3b82f6"></span>İnceleniyor</span></nz-option>
              <nz-option nzValue="Onarılıyor" nzLabel="Onarılıyor" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#f59e0b"></span>Onarılıyor</span></nz-option>
              <nz-option nzValue="Tamamlandı" nzLabel="Tamamlandı" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#22c55e"></span>Tamamlandı</span></nz-option>
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Yapılan İşlem</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('yapilanIslem')" (ngModelChange)="guncelle('yapilanIslem', $event)" placeholder="Yapılan işlem..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Açıklama</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('aciklama')" (ngModelChange)="guncelle('aciklama', $event)" placeholder="Açıklama..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [EDIT_STILLER],
})
export class DurumGuncellemeEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}
